// extracted by mini-css-extract-plugin
export default {"root":"_3ljKse5I","inList":"_16le_rGC"};